import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25RouterLinkDirective } from "../../s25-nav-bar/s25.router.link.directive";
import { S25States } from "../../../services/state/state.map";
import type { SeUserTileOrganization } from "./se.user.search.service";

@TypeManagerDecorator("s25-ng-se-user-search-orgs-cell")
@Component({
    selector: "s25-ng-se-user-search-orgs-cell",
    standalone: true,
    imports: [CommonModule, S25RouterLinkDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (organizationsInput().length) {
            @for (
                organizationBlock of organizationsInput();
                track organizationBlock.organizationId + "|" + organizationBlock.organizationName;
                let organizationIndex = $index
            ) {
                @if (organizationIndex > 0) {
                    <span class="orgs-sep">, </span>
                }
                <a
                    class="connect25-detail-link"
                    s25-ng-router-link
                    [stateName]="seOrganizationDetailsStateName"
                    [stateParams]="organizationDetailLinkParams(organizationBlock)"
                >
                    {{ organizationBlock.organizationName }}
                </a>
            }
        } @else {
            —
        }
    `,
    styles: `
        .orgs-sep {
            color: #4b5563;
        }
        .connect25-detail-link {
            font-weight: 500;
            color: var(--color--link-text, #0c447c);
            text-decoration: none;
        }
        .connect25-detail-link:hover {
            text-decoration: underline;
        }
    `,
})
export class SeUserSearchOrganizationsCellComponent {
    readonly organizationsInput = input<SeUserTileOrganization[]>([], { alias: "organizations" });

    readonly seOrganizationDetailsStateName = S25States.names.seOrganizationDetails;

    organizationDetailLinkParams(
        organizationBlock: SeUserTileOrganization,
    ): S25States.ParamsForName<"seOrganizationDetails"> {
        return { itemId: organizationBlock.organizationId };
    }
}
